
import { computed, defineComponent, PropType, ref, watch, watchEffect } from 'vue'
import { QSelect } from 'quasar'

export default defineComponent({
  name: 'LabelBox',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    editing: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array as PropType<{ label: string, value: any }[]>,
      default: () => []
    }
  },
  emits: ['update:model-value'],
  setup (props) {

    const isColor = (() => {
      const s = new Option().style
      s.color = props.modelValue
      return s.color !== ''
    })()

    const qSelect = ref<QSelect | null>(null)
    const qSelectInput = computed(() => qSelect.value?.$el?.querySelector('input'))

    watch(() => [qSelectInput.value, props.label], () => {
      if (!qSelectInput.value) return
      if (props.modelValue || props.label) {
        setInputWidth(props.modelValue)
      } else {
        if (qSelectInput.value.getAttribute('size') === '1') return
        qSelectInput.value.setAttribute('size', '1')
      }
    })

    const setInputWidth = (text: string | null) => {
      if (!qSelectInput.value) return
      const size = Math.max(
        (text ?? '').length,
        1,
        Math.ceil((qSelectInput.value.getAttribute('aria-label') ?? '').length / 2),
      )
      qSelectInput.value.setAttribute('size', size.toString())
    }

    const filterOptions = ref<{ label: string, value: any }[]>([])

    const selectFilter = (val, update) => {
      update(() => {
        if (val === '') {
          filterOptions.value = props.options
        } else {
          const needle = val.toLowerCase()
          filterOptions.value = props.options.filter(
            option => option['label'].toLowerCase().indexOf(needle) > -1
          )
        }
      })
    }

    return {
      isColor,
      qSelect,
      setInputWidth,
      selectFilter,
      filterOptions,
    }
  }
})
